"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UniversalTokenProvider = void 0;
var _tokenContext = require("./tokenContext");
var _useUniversalToken = require("./useUniversalToken");
var _jsxRuntime = require("react/jsx-runtime");
var UniversalTokenProvider = function(param) {
    var children = param.children, customerId = param.customerId, initialToken = param.initialToken;
    var contextValue = (0, _useUniversalToken.useUniversalToken)({
        customerId: customerId,
        initialToken: initialToken
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_tokenContext.tokenContext.Provider, {
        value: contextValue,
        children: children
    });
};
exports.UniversalTokenProvider = UniversalTokenProvider; //# sourceMappingURL=UniversalTokenProvider.js.map
